import {
    PURCHASE,
    INPUT_TYPE,
    REFINANCE_LIMITED,
    REFINANCE_CASHOUT,
    ID_FIRST_BUYER_RATE,
    ID_15YR_VA_RATE,
    ID_30YR_VA_RATE,
    ID_30YR_USDA_RATE,
    ID_15YR_FHA_RATE,
    ID_30YR_FHA_RATE,
    ID_15YR_JUMBO_RATE,
    ID_20YR_JUMBO_RATE,
    ID_30YR_JUMBO_RATE,
    ID_FTHB_40YR_FIXED_15YR_BALLOON_RATE,
    ID_FTHB_7_6_ARM_RATE,
} from "./validatorConstants";
import { getTranslation } from "./translations";

export function validate(value, type) {
    switch (type) {
        case (INPUT_TYPE.TEXT):
            return value !== "" ? true : false;
        case (INPUT_TYPE.EMAIL):
            if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) && value !== "") {
                return true;
            }
            return false;
        case (INPUT_TYPE.NUMBER):
            return !isNaN(value) || value <= 0 ? true : false;
        case (INPUT_TYPE.SELECT):
            return value !== "" ? true : false;
        default:
            break;
    }
}

/**
 * TODO: combine this function with checkForNull and validate all in one
 * but this will affect a bunch of other code that relies on it and needs testing
 *
 * @param values
 */
export function validateArrayObjects(values) {
    let isValid = true;
    Object.keys(values).forEach(key => {
        if (isValid) {
            if (values[key].required) {
                if (!values[key].isValid) {
                    isValid = false;
                }

                const value = values[key].value;

                if (!value) {
                    isValid = false;
                } else if (typeof value === INPUT_TYPE.STRING) {
                    if (!value || value.trim() === "") {
                        isValid = false;
                    }
                } else if (typeof value === INPUT_TYPE.NUMBER) {
                    if (!value || value <= 0) {
                        isValid = false;
                    }
                }
            }
        }
    });
    return isValid;
}

//if an array contains any NULL return TRUE
export function checkForNull(values) {
    let isNull = false;
    Object.keys(values).forEach(key => {
        if (values[key].required) {
            const value = values[key].value;
            if (!value) {
                isNull = true;
            } else if (typeof value === INPUT_TYPE.STRING) {
                if (!value || value.trim() === "") {
                    isNull = true;
                }
            } else if (typeof value === INPUT_TYPE.NUMBER) {
                if (!value || value <= 0) {
                    isNull = true;
                }
            }
        }
    });
    return isNull;
}

//LTV FORM 2020
// Product  	                    MAXLTV	Max Loan Amount

//THESE NEED TO BE HANDLED
// 1XClose Construction	            95%	    $510,400 (conforming loan limits)
// 2-step Construction	            95%	    $1,000,000
// VA	                            100%	$510,400 (conforming loan limits)
// USDA Rural	                    100%	$114,650
// Lot Loans	                     80%	    $510,400
// FHA	                            96.50%	$331,760 but will vary by county
// Jumbo	                        95%
// THESE ARE HANDLED NOW....
// ---------Conventional	        95%	    $510,400
//---------- Refi	                95%	    $510,400
//---------- Cash-out Refi	        80%
// --------- First-time Homebuyer	100%	$300,000
//validate the form elemenets
export function validateFormElements(loanPurpose, downPayment, refinanceAmount, purchasePrice, currentHomeValue, id = -1, firstTimeLimit, maxLoanLimit, maxLTV, lang) {
    const jumboLoans = [ID_15YR_JUMBO_RATE, ID_20YR_JUMBO_RATE, ID_30YR_JUMBO_RATE];
    const translations = getTranslation(lang);
    let LTV;
    let loanValue;
    if (loanPurpose === PURCHASE) {
        LTV = 100 - (downPayment / purchasePrice) * 100;
        loanValue = parseInt(purchasePrice) - parseInt(downPayment);
    } else {
        LTV = (refinanceAmount / currentHomeValue) * 100;
        loanValue = parseInt(refinanceAmount);
    }
    let error = { isError: false, message: "" };

    switch (loanPurpose) {
        case (PURCHASE):

            if (loanValue <= 0) {
                error = { isError: true, message: translations.downPaymentLargerThanPurchasePrice };
            }

            if (maxLTV < 100) {
                if (LTV > maxLTV ) {
                    error = { isError: true, message: translations.enterDownPaymentMinimum.replace("{0}", (100 - maxLTV).toString()) };
                }
            }

            if (ID_FIRST_BUYER_RATE === id) {
                if (firstTimeLimit < 0) {
                    error = { isError: true, message: translations.failedToLoad };
                }
                else if (firstTimeLimit === 0) {
                    error = { isError: true, message: translations.loading };
                }
                else if (loanValue > firstTimeLimit) {
                    const firstTimeLimitFormat = firstTimeLimit.toLocaleString();
                    error = { isError: true, message: translations.youCannotExceedLoan.replace("{0}", firstTimeLimitFormat.toString()) };
                }
            } else if (jumboLoans.includes(id)) {
                if (loanValue < maxLoanLimit){
                    error = { isError: true, message: translations.loanCantBeLessThan.replace('{0}', maxLoanLimit.toLocaleString()) };
                }
            } else if (loanValue > maxLoanLimit) {
                error = { isError: true, message: translations.loanCantBeLargerThan.replace('{0}', maxLoanLimit.toLocaleString()) };
            }

            break;
        case (REFINANCE_LIMITED):
        case (REFINANCE_CASHOUT):
            if (loanValue <= 0) {
                error = { isError: true, message: translations.refinanceCantBeGreaterThanHomeValue };
            }

            if (LTV > maxLTV) {
                error = { isError: true, message: translations.ltvShouldBeValueOrLess.replace('{0}', maxLTV.toLocaleString()) };
            }

            break;
        default:
            break;
    }
    return error;
}